import { motion} from "framer-motion";

import our_services from "../data/our_services";

/* =======================================================
   Premium Service Card
======================================================= */

function ServiceCard({ service, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{
        duration: 0.6,
        delay: index * 0.12,
      }}
      whileHover={{
        y: -12,
      }}
      className="group h-full"
    >
      <div className="relative h-full overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 sm:p-6 lg:p-8 shadow-[0_15px_40px_rgba(15,23,42,.08)] transition-all duration-500 hover:border-indigo-200 hover:shadow-[0_30px_80px_rgba(79,70,229,.18)]">

        {/* Number */}

        <span className="absolute right-5 top-5 text-2xl md:text-4xl font-black text-slate-100">
          {String(index + 1).padStart(2, "0")}
        </span>

        {/* Icon */}

        <div className="flex items-center gap-3 sm:block">

              {/* Icon */}
              <div className="flex h-10 w-10 sm:h-16 sm:w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-500 text-white shadow-lg transition duration-500 group-hover:rotate-6 group-hover:scale-110 flex-shrink-0">
                {service.icon}
              </div>

              {/* Title */}
              <h3 className="text-lg sm:mt-6 sm:text-2xl font-bold text-slate-900 transition-all duration-300 group-hover:bg-gradient-to-r group-hover:from-indigo-600 group-hover:via-purple-600 group-hover:to-pink-500 group-hover:bg-clip-text group-hover:text-transparent">
                {service.title}
              </h3>

              </div>
        {/* Description */}

        <p className="mt-3 text-sm sm:text-base leading-6 sm:leading-7 text-slate-600">

          {service.desc}

        </p>

      </div>
    </motion.div>
  );
}
/* =======================================================
   Services Section
======================================================= */

export default function Services() {
  return (
    <section
      id="services"
      className="relative overflow-hidden bg-gradient-to-b from-white via-[#faf8ff] to-[#f5f3ff] py-12 sm:py-14 md:py-16"
    >
      {/* Background Glow */}

      <div className="absolute -top-40 -left-40 h-[420px] w-[420px] rounded-full bg-purple-400/20 blur-[140px]" />

      <div className="absolute bottom-0 right-0 h-[500px] w-[500px] rounded-full bg-indigo-400/20 blur-[160px]" />

      {/* Grid Pattern */}

      <div className="absolute inset-0 opacity-[0.03] bg-[linear-gradient(#000_1px,transparent_1px),linear-gradient(90deg,#000_1px,transparent_1px)] bg-[size:45px_45px]" />

      {/* Floating Decorations */}

      <motion.div
        animate={{
          y: [0, -20, 0],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
        }}
        className="absolute left-16 top-40 h-8 w-8 rounded-full bg-purple-300/30 blur-sm"
      />

      <motion.div
        animate={{
          y: [0, 20, 0],
        }}
        transition={{
          duration: 7,
          repeat: Infinity,
        }}
        className="absolute right-24 bottom-32 h-10 w-10 rounded-full bg-indigo-300/30 blur-sm"
      />

        <div className="relative mx-auto max-w-6xl px-4 md:px-6">

        {/* Badge */}
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex justify-center"
        >
          <span className="rounded-full border border-purple-200 bg-purple-100/80 px-3 sm:px-5 py-1.5 sm:py-2 text-[11px] sm:text-sm font-semibold tracking-wide text-purple-700 shadow-md backdrop-blur">
            🚀 OUR SERVICES
          </span>
        </motion.div>

        {/* Heading */}
        <motion.h2
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mx-auto mt-4 sm:mt-6 max-w-4xl text-center text-2xl sm:text-4xl md:text-5xl font-black leading-tight text-gray-900"
        >
          Digital Solutions

          <span className="block bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 bg-clip-text text-transparent">
            That Accelerate Growth
          </span>
        </motion.h2>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mx-auto mt-3 sm:mt-5 max-w-2xl text-xs sm:text-base md:text-lg leading-5 sm:leading-7 text-gray-600"
        >
          From websites and mobile applications to AI automation,
          branding, and digital marketing, we build scalable digital
          experiences that help businesses stand out and grow faster.
        </motion.p>

        {/* Divider */}
        <motion.div
          initial={{ width: 0 }}
          whileInView={{ width: 100 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="mx-auto mt-5 sm:mt-8 h-1 rounded-full bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 sm:w-32"
        />

        {/* Services Grid */}
        <div className="mt-6 sm:mt-10 grid gap-4 sm:gap-6 lg:gap-8 md:grid-cols-2 xl:grid-cols-3">
          {our_services.map((service, index) => (
            <ServiceCard
              key={index}
              service={service}
              index={index}
            />
          ))}
        </div>

        </div>
    </section>
  );
}
